import { render, staticRenderFns } from "./OpportunityCard.vue?vue&type=template&id=b9cff8b6"
import script from "./OpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpportunityCard.vue?vue&type=script&lang=js"
import style0 from "./OpportunityCard.vue?vue&type=style&index=0&id=b9cff8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports